// Wrapper Component for the Mantine Tooltip
import { ReactElement, ReactNode } from 'react';
import { Tooltip as MantineTooltip } from '@mantine/core';

// Link to Mantine Tooltip Component: https://mantine.dev/core/tooltip/

type Props = {
  tooltipMessage: string;
  children: ReactNode;
}

export function Tooltip({
  tooltipMessage,
  children,
}: Props): ReactElement {
  return (
    <MantineTooltip
      label={tooltipMessage}
      events={{
        hover: true,
        focus: false,
        touch: true,
      }}
    >
      {children}
    </MantineTooltip>
  );
}
